<template>
  <div>
    <el-row class="el-row-topo">
      <el-col :span="24">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item>Orçamento Painel Elétrico</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center">
      <el-col :span="24">
        <h1>Registro de Orçamentos Painel Elétrico</h1>
      </el-col>
    </el-row>
    <el-row v-if="permissao.editar_painel" type="flex" justify="left">
      <el-col :xs="24" :sm="24" :md="20" :lg="2" :xl="1">
        <h1>
          <router-link to="/cadOrcamento">
            <el-button type="primary" icon="el-icon-circle-plus-outline" round>Novo</el-button>
          </router-link>
        </h1>
        <router-view />
      </el-col>
      <el-col :xs="24" :sm="24" :md="20" :lg="22" :xl="20">
        <!-- <el-form :inline="true" :model="formPesquisa" class="form-inline-pesquisa">
           <el-form-item label="">
            <el-input v-model="formPesquisa.pesquisa" placeholder="Pesquisa por...">
                  <el-button slot="append" @click="onSubmitPesquisa" icon="el-icon-search"></el-button>            
            </el-input>
          </el-form-item> 
        </el-form>-->
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="24">
        <el-table
          :data="itens"
          style="width: 100%"
          stripe
          v-loading="loading"
          element-loading-text="Loading..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255, 255, 255, 0.7)"
        >
          <el-table-column prop="id" label="Id" width="100" sortable></el-table-column>
          <el-table-column prop="sge_orcamento" label="Número do Negócio"></el-table-column>
          <el-table-column prop="revisao" label="Revisão"></el-table-column>
          <el-table-column prop="cliente" label="Cliente"></el-table-column>
          <el-table-column prop="acao" label="Ação" width="200" filter-placement="bottom-end">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip v-if="permissao.editar_painel" class="item" effect="light" content="Gerar Proposta" placement="top">
                  <el-button
                    size="mini"
                    type="info"
                    @click="handleProposta(scope.$index, scope.row)"
                    icon="el-icon-receiving"
                  ></el-button>
                </el-tooltip> 
                <el-tooltip v-if="permissao.editar_painel" class="item" effect="light" content="Visualizar" placement="top">
                  <el-button
                    size="mini"
                    type="info"
                    @click="handleVisualizar(scope.$index, scope.row)"
                    icon="el-icon-notebook-2"
                  ></el-button>
                </el-tooltip>                
                <el-tooltip v-if="permissao.editar_painel" class="item" effect="light" content="Nova Versão" placement="top">
                  <el-button
                    size="mini"
                    type="primary"
                    @click="handleEdit(scope.$index, scope.row)"
                    icon="el-icon-document-copy"
                  ></el-button>
                </el-tooltip>                
                <el-tooltip v-if="permissao.excluir_painel" class="item" effect="light" content="Excluir" placement="top">
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)"
                    icon="el-icon-delete"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="prev, pager, next"
          background
          :total="total"
        ></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<style>
.el-row-topo {
  margin-top: 10px;
}
</style>

<script>
import axios from "axios";
import FuncoesUteis from "../../plugins/FuncoesUteis";

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

var validatePass = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("Informe a senha."));
  } else {
    callback();
  }
};
var validatePass2 = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("Repita a senha."));
  } else if (value !== document.getElementById("pass").value) {
    callback(new Error("A senha e a repetição de senha devem ser iguais!"));
  } else {
    callback();
  }
};

export default {
  data() {
    return {
      loading: true,
      total: 0,
      pageSize: 12,
      listLoading: false,
      currentPage: 1,
      itens: [],
      permissao: {},
      labelPosition: "right",
      dialogFormVisibleEdit: false,
      formPesquisa: {
        pesquisa: "",
      },
      ruleFormEdit: {
        nome: "",
        email: "",
        id: "",
      },
      rules: {
        nome: [
          {
            required: true,
            message: "Por Favor, informe o Nome",
            trigger: "blur",
          },
          {
            min: 3,
            message: "Deve ter pelo menos 3 caracteres",
            trigger: "blur",
          },
        ],
        email: [
          { required: true, message: "Informe o e-mail.", trigger: "blur" },
          {
            type: "email",
            message: "Informe um e-mail válido.",
            trigger: ["blur", "change"],
          },
        ],
      },
      dialogFormVisibleEditPass: false,
      ruleFormEditPass: {
        nome: "",
        email: "",
        id: "",
        pass: "",
        checkPass: "",
      },
      rulesPass: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
      },
    };
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
  },
  mounted() {
    this.permissao = FuncoesUteis.isPermissao();
    if (!this.permissao.ler_painel) {
      this.$message.error("Você não tem permissão para acessar esta página.");
      this.$router.push("/");
      return;
    }
    this.loading = true;
    axios
      .get(url + "/orclist/", {
        headers: {
          Authorization: "Bearer " + this.$store.state.token,
        },
      })
      .then((response) => {
        if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          this.total = response.data.length;
        }
      })
      .catch((err) => {
        this.total = "erro" + err;
      });

    axios
      .get(url + "/orclist/0/" + this.pageSize, {
        headers: {
          Authorization: "Bearer " + this.$store.state.token,
        },
      })
      .then((response) => {
        this.itens = response.data;
        this.loading = false;
      })
      .catch((err) => {
        this.itens = "erro" + err;
      });
  },
  methods: {
    //PESQUISA
    onSubmitPesquisa() {
      this.loading = true;
      let dados = {
        pesquisa: this.formPesquisa.pesquisa,
      };
      axios
        .post(url + "/userssearch/0/" + this.pageSize, dados, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {
          this.itens = response.data.dados;
          this.loading = false;
          this.total = response.data.total;
          this.currentPage = 1;
        })
        .catch((err) => {
          this.itens = "erro" + err;
        });
    },
    //FIM PESQUISA
    //PAGINAÇÃO
    handleSizeChange: function (size) {
      this.pageSize = size;
      let comeca_em;
      if (this.currentPage == 1) {
        comeca_em = 0;
      } else {
        comeca_em = (this.currentPage - 1) * this.pageSize;
      }
      this.getDados(comeca_em, this.pageSize);
    },
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      let comeca_em;
      if (currentPage == 1) {
        comeca_em = 0;
      } else {
        comeca_em = (currentPage - 1) * this.pageSize;
      }
      this.getDados(comeca_em, this.pageSize);
    },

    //FIM PAGINAÇÃO
    //LISTAR DADOS
    getDados(paginaCorrente = 0, TamanhoPagina = "") {
      if (this.formPesquisa.pesquisa != "") {
        let dados = {
          pesquisa: this.formPesquisa.pesquisa,
        };
        axios
          .post(
            url + "/orcsearch/" + paginaCorrente + "/" + this.pageSize,
            dados,
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            }
          )
          .then((response) => {
            this.itens = response.data.dados;
            this.total = response.data.total;
            this.currentPage = paginaCorrente;
          })
          .catch((err) => {
            this.itens = "erro" + err;
          });
      } else {
        if (!TamanhoPagina) {
          TamanhoPagina = this.pageSize;
        }
        axios
          .get(url + "/orclist/" + paginaCorrente + "/" + TamanhoPagina, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          })
          .then((response) => {
            this.itens = response.data;
          })
          .catch((err) => {
            this.itens = "erro" + err;
          });
      }
    },
    
    //FIM LISTAR DADOS
    //EDITAR
    handleEdit(index, row) {
      //this.$router.push({ name: "editOrcamento", params: { id: row.id } });
      this.$router.push({ name: "cadNovaVersao", params: { id: row.id } });
    },
    //FIM EDITAR
    //VISUALIZAR
    handleVisualizar(index, row) {
      this.$router.push({ name: "visOrcamento", params: { id: row.id } });
    },
    //FIM VISUALIZAR

    //GERAR PROPOSTA
    handleProposta(index, row) {
      this.$router.push({ name: "gerarProposta", params: { id: row.id } });
    },
    //FIM VISUALIZAR    

    //EXCLUIR
    handleDelete(index, row) {
      this.$confirm("Tem certeza que deseja excluir este registro?", "Aviso", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancelar",
        type: "warning",
      })
        .then(() => {
          axios
            .delete(url + "/orcamentos/" + row.id, {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then(() => {
              //this.itens = response.data;
              this.$notify({
                title: "Sucesso",
                message: "Registro excluído com Sucesso!",
                type: "success",
              });
              this.getDados();
            })
            .catch((err) => {
              this.$notify({
                title: "Erro",
                message:
                  "Erro ao excluir os dados! Tente novamente mais tarde!" + err,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    //FIM EXCLUIR
  },
};
</script>
<style>
.form-inline-pesquisa {
  margin-top: 15px;
  text-align: left;
  padding-left: 50px;
}
</style>